import JourneyListPanelComponent from '@/components/proficiency/journey-list-panel/journey-list-panel';
import { UserClassModel } from '@/models/class/class';
import { SubjectModel } from '@/models/taxonomy/subject';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'facet-route-info-content',
    components: {
        'journey-list-panel': JourneyListPanelComponent,
    },
})

export default class FacetRoutInfoComponent extends Vue {

    // -------------------------------------------------------------
    // Properties

    @Prop()
    private userClassList!: UserClassModel[];

    @Prop()
    private activeFacets!: SubjectModel[];

    @Prop()
    private userId!: string;




}
